/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.initFreeGiftHandler();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  /**
   * Initialize free gift button handler using event delegation
   */
  initFreeGiftHandler() {
    // Use event delegation so it works for dynamically added buttons
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-free-gift-add]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        this.handleFreeGiftAdd(btn);
      }
    });
  }

  /**
   * Handle free gift add to cart
   * @param {HTMLElement} btn - The add button element
   */
  handleFreeGiftAdd(btn) {
    if (btn.classList.contains('is-disabled') || btn.dataset.processing) return;
    btn.dataset.processing = 'true';

    const id = btn.dataset.variantId;
    btn.classList.add('is-disabled');
    btn.textContent = 'Adding...';

    const drawer = this;
    const header = document.querySelector('page-header');
    const sections = [];
    if (drawer && drawer.dataset.sectionId) sections.push(drawer.dataset.sectionId);
    if (header && header.dataset.sectionId) sections.push(header.dataset.sectionId);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((data) => {
        btn.textContent = 'Added';
        document.querySelectorAll('.free-gift-section').forEach((s) => {
          s.style.display = 'none';
        });

        if (data.sections) {
          if (drawer && data.sections[drawer.dataset.sectionId]) {
            const temp = document.createElement('div');
            temp.innerHTML = data.sections[drawer.dataset.sectionId];
            const newDrawer = temp.querySelector('cart-drawer');
            if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          }
          if (header && data.sections[header.dataset.sectionId]) {
            const temp2 = document.createElement('div');
            temp2.innerHTML = data.sections[header.dataset.sectionId];
            const newCount = temp2.querySelector('[data-header-cart-count]');
            const oldCount = header.querySelector('[data-header-cart-count]');
            if (newCount && oldCount) oldCount.textContent = newCount.textContent;
          }
        }

        if (window.location.pathname !== '/cart' && drawer) {
          setTimeout(() => {
            if (drawer.open) {
              drawer.open(btn);
            } else {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            }
          }, 50);
        }
      })
      .catch(() => {
        btn.textContent = 'Add';
        btn.classList.remove('is-disabled');
        delete btn.dataset.processing;
      });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
